import { useLocation, useNavigate } from "react-router-dom";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import SettingsProgs from "./settings-progs";
import SettingsPays from "./settings-pays";
import SettingsTags from "./settings-tags";
import SettingsBanners from "./settings-banners";
import { useSelector } from "react-redux";
import "./settings.css";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((s) => s.user);

  const items = [
    {
      key: "/settings",
      label: "Программы",
      children: <SettingsProgs />,
    },
    {
      key: "/settings/pays",
      label: "Виды оплат",
      children: <SettingsPays />,
    },
    {
      key: "/settings/tags",
      label: "Метки",
      children: <SettingsTags />,
    },
    ...(user?.admin
      ? [
          {
            key: "/settings/banners",
            label: "Баннеры",
            children: <SettingsBanners />,
          },
        ]
      : []),
  ];

  const activeKey = items.find(item => location.pathname === item.key)?.key || items[0].key;

  const onTabChange = (key) => {
    navigate(key);
  };

  return (
    <div className="page settings-page">
      <MultiPane
        activeKey={activeKey}
        items={items}
        onChange={onTabChange}
        type="card"
      />
    </div>
  );
};

export default Settings;